import React from 'react';
import { useTranslation } from 'react-i18next';
import { MicroInteractionButton } from '../../../molecules/MicroInteractionButton/MicroInteractionButton';
import { Icons, SVGIcon } from '../../../atoms/SVG';
import { BtnModifier } from '../../../molecules/Btn';
import { InteractionStatus } from '../../../../types/InteractionStatus';
import { TooltipPlacement } from '../../../atoms/Tooltip';

export type FavoriteButtonInteractionsProps = {
  active: boolean;
  svgspriteId: SVGIcon;
  color:
    | BtnModifier.MINOR_ACTION_ACTIVATED_DARK
    | BtnModifier.MINOR_ACTION_ACTIVATED_PETROL
    | BtnModifier.MINOR_ACTION_ACTIVATED_RED;
  favoriteText: string;
  noFavoriteText: string;
  translationNamespace: 'Announcement' | 'PageInteractions' | 'PersonInteraction';
  currentInteractionStatus: string;
};

export function FavoriteButtonInteractions(props: FavoriteButtonInteractionsProps) {
  const { t } = useTranslation();

  const getCurrentInteraction = (status: string) => {
    if (status === InteractionStatus.SUCCESS || status === InteractionStatus.NONE) {
      return props.active ? 'FAVORITE' : 'NO_FAVORITE';
    }
    return status;
  };

  return (
    <MicroInteractionButton
      type="submit"
      modifier={[BtnModifier.MICRO_INTERACTION, BtnModifier.TRANSPARENT, BtnModifier.MINOR_ACTION]}
      svgSpriteId={props.svgspriteId}
      hiddenText
      text={props.noFavoriteText}
      titleText={props.noFavoriteText}
      tooltipPlacement={TooltipPlacement.TOP}
      currentInteraction={getCurrentInteraction(props.currentInteractionStatus)}
      interactions={{
        NO_FAVORITE: {
          svgSpriteId: props.svgspriteId,
          modifier: [BtnModifier.MICRO_INTERACTION, BtnModifier.TRANSPARENT, BtnModifier.MINOR_ACTION],
          text: props.noFavoriteText,
          titleText: props.noFavoriteText,
        },
        FAVORITE: {
          svgSpriteId: props.svgspriteId,
          modifier: [
            BtnModifier.MICRO_INTERACTION,
            BtnModifier.TRANSPARENT,
            BtnModifier.MINOR_ACTION,
            BtnModifier.MINOR_ACTION_ACTIVATED,
            props.color,
          ],
          text: props.favoriteText,
          titleText: props.favoriteText,
        },
        [InteractionStatus.FAIL]: {
          svgSpriteId: Icons.FEEDBACK_ERROR,
          modifier: [
            BtnModifier.MICRO_INTERACTION,
            BtnModifier.TRANSPARENT,
            BtnModifier.MINOR_ACTION,
            BtnModifier.MINOR_ACTION_FAILED,
          ],
          text: t(`${props.translationNamespace}:favoriteButtonForm.failure.buttonText`),
          titleText: t(`${props.translationNamespace}:favoriteButtonForm.failure.buttonTitleText`),
        },
        [InteractionStatus.SENDING]: {
          modifier: [
            BtnModifier.MICRO_INTERACTION,
            BtnModifier.TRANSPARENT,
            BtnModifier.MINOR_ACTION,
            BtnModifier.MINOR_ACTION_BUSY,
          ],
          text: t(`${props.translationNamespace}:favoriteButtonForm.status.sending`),
          titleText: null,
        },
      }}
    />
  );
}
